<template>
  <div class="mini-pay">
    <div v-if="!paid">
      <!-- 用户信息头部 -->
      <div class="head">
        <div class="name">{{ name }}</div>
        <div class="img">
          <img :src="avatar" alt="用户头像" />
        </div>
      </div>

      <!-- 支付信息 -->
      <div class="msg">
        <div class="item">
          <div class="item-name">练车金额</div>
          <div class="item-value">￥{{ totalAmount }}</div>
        </div>
        <div class="item">
          <div class="item-name">累计学时</div>
          <div class="item-value">{{ totalDuration }}</div>
        </div>
      </div>

      <!-- 支付按钮 -->
      <button class="pay-btn" @click="handlePayment">
        赞赏
        <i
          v-if="isPaying"
          class="weui-loading"
          style="width: 25px; height: 25px; margin-left: 0.1rem"
        ></i>
      </button>
      <span>{{ studentId }}</span>
      <span>{{ softSn }}</span>

      <!-- 用户协议 -->
      <div class="pay-agree">
        <div class="wrap">
          <div
            class="pay-agree_select"
            @click="toggleAgreement"
            :class="isAgreementSelected ? 'selected' : ''"
          >
            <div class="success"></div>
          </div>
        </div>
        <div style="width: 6.5rem" @click="toggleAgreement">
          <div class="pay-agree_title">
            我已阅读并同意
            <span style="color: #0093f0" @click.stop="goToAgreementDetail"
              >《路考仪学员协议》</span
            >
          </div>
          <!-- <div class="pay-agree_content">
            使用路考仪练车，是学员自愿行为。若有任何强制行为，
            请与我们反应或投诉，客服热线：
            <a style="color: #0093f0" href="tel:13127832213">13127832213</a>
          </div> -->
        </div>
      </div>

      <!-- 广告 banner -->
      <div class="insurance-banner" v-if="bannerImg">
        <img :src="bannerImg" alt="保险广告" @click="navigateToInsurance" />
      </div>
    </div>

    <!-- 提示对话框 -->
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="dialogMessage"></dialog-item>
    </div>
  </div>
</template>

<script>
import "weui";
import { hostUrl, OPENIDNEW } from "../http/env.js";
import {
  unpaidById,
  pushStudentOrder,
  pay,
  depositBanner,
  getAdCode,
} from "@/http/api";
import { setTimeout } from "timers";
import dialogItem from "./dialog";
import store from "../pages/advise/store";

export default {
  name: "MiniPay",
  props: {
    studentId: {
      type: String,
      required: true,
    },
    softSn: {
      type: String,
      required: true,
    },
    openid: {
      type: String,
      default: "",
    },
  },
  components: {
    dialogItem,
  },
  data() {
    return {
      showDialog: false,
      dialogMessage: "",
      publicPath: process.env.PUBLICK_PATH,
      isPaying: false,
      paid: false,
      name: "",
      totalAmount: 0,
      totalDuration: 0,
      avatar: "",
      serialNumber: "",
      channel: "",
      checkVal: "",
      isAgreementSelected: false,
      bannerImg: "",
      bannerUrl: "",
      coachId: "",
      orderList: [],
      isTrackPlay: 0,
      trackPlayObj: {},
      adCode: "",
      isInitialized: false,
    };
  },
  computed: {
    // 检查是否可以进行支付
    canPay() {
      return (
        !this.isPaying && this.isAgreementSelected && this.orderList.length > 0
      );
    },
  },
  watch: {
    // 监听 studentId 和 softSn 的变化，当两者都有值时执行初始化
    studentId: {
      handler(newVal) {
        this.checkAndInitialize();
      },
      immediate: true,
    },
    softSn: {
      handler(newVal) {
        this.checkAndInitialize();
      },
      immediate: true,
    },
  },
  methods: {
    // 检查参数是否有效并初始化
    checkAndInitialize() {
      // 防止重复初始化
      if (this.isInitialized) {
        return;
      }

      if (!this.openid) {
        this.getOpenIdNew();
      }

      console.log("学员ID:", this.studentId, "软件序列号:", this.softSn);
      this.initializePayment();
      this.fetchAdCode();
      this.isInitialized = true;
    },

    // 获取广告代码
    async fetchAdCode() {
      try {
        const res = await getAdCode({ student_id: this.studentId });
        if (res.code === 0) {
          this.adCode = res.data.ad_code || "";
          await this.fetchBanner({ bannerType: 104, ad_code: this.adCode });
        }
      } catch (error) {
        console.error("获取广告代码失败:", error);
      }
    },

    // 获取广告横幅
    async fetchBanner(params) {
      try {
        const res = await depositBanner(params);
        if (res.data.list.length > 0) {
          this.bannerImg = res.data.list[0].imageUrl || "";
          this.bannerUrl = res.data.list[0].url || "";
        }
      } catch (error) {
        console.error("获取广告横幅失败:", error);
      }
    },

    // 切换协议选中状态
    toggleAgreement() {
      this.isAgreementSelected = !this.isAgreementSelected;
      store.checked = this.isAgreementSelected;
    },

    // 显示提示对话框
    showNotification(message) {
      this.showDialog = true;
      this.dialogMessage = message;
      setTimeout(() => {
        this.showDialog = false;
        this.dialogMessage = "";
      }, 1500);
    },

    // 跳转到保险页面
    navigateToInsurance() {
      window.location.href = this.bannerUrl;
    },

    // 初始化支付信息
    async initializePayment() {
      try {
        const res = await unpaidById({
          student_id: this.studentId,
          soft_sn: this.softSn,
        });

        // 设置用户信息和订单数据
        this.avatar = res.data.avatar;
        this.name = res.data.name;
        this.totalAmount = res.data.total_amount;
        this.totalDuration = res.data.total_duration;
        this.isTrackPlay = res.data.is_trackplay;

        // 处理轨迹回放数据
        if (this.isTrackPlay === 1) {
          this.trackPlayObj = res.data.list[0];
        }

        // 构建订单详情列表
        const orderDetails = res.data.list.map((item) => ({
          id: item.order_id,
        }));
        this.orderList = orderDetails;

        // 设置教练ID
        if (res.data.list.length > 0) {
          this.coachId = res.data.list[0].coach_id;
        }

        // 提交学员订单
        await this.submitStudentOrder(orderDetails);
      } catch (error) {
        console.error("初始化支付信息失败:", error);
        this.showNotification(
          "请求失败，请检查网络后重试2",
          window.location.search,
          "===>window.location.search"
        );
      }
    },

    // 提交学员订单
    async submitStudentOrder(orderDetails) {
      try {
        // 确定支付类型
        const payType = "1";

        const orderParams = {
          soft_sn: this.softSn, // 软件编号
          coach_id: this.coachId, // 教练ID
          student_id: this.studentId, // 学员ID
          pay_type: payType, // 支付类型 1:微信, 2:支付宝
          amount: this.totalAmount, // 金额
          pay_platform: "wap", // 支付平台
          detail: JSON.stringify(orderDetails), // 订单详情
        };

        const res = await pushStudentOrder(orderParams);
        if (res.code === 0) {
          this.serialNumber = res.data.data.serial_number;
        }
      } catch (error) {
        console.error("提交学员订单失败:", error);
      }
    },

    // 处理支付
    async handlePayment() {
      // 支付状态检查
      if (this.isPaying) {
        return;
      }

      if (!this.isAgreementSelected) {
        this.showNotification("请阅读并同意使用须知");
        return;
      }

      if (this.orderList.length === 0) {
        this.showNotification("该账号暂无欠费订单！");
        return;
      }

      try {
        this.isPaying = true;
        // 设置支付超时自动取消
        const payTimeout = setTimeout(() => {
          this.isPaying = false;
        }, 5000);

        // 执行支付
        await this.executePayment();

        // 清除超时计时器
        clearTimeout(payTimeout);
      } catch (error) {
        console.error("支付处理失败:", error);
        this.isPaying = false;
        this.showNotification("请求失败，请检查网络后重试");
      }
    },
    // 车轮驾考通app获取openid
    getOpenIdNew() {
      var url = window.location.href;
      var href =
        `${OPENIDNEW}/xc_v1/Wechat/getOpenId?source=` + encodeURIComponent(url);
      window.location.href = href;
    },

    // 执行支付请求
    async executePayment() {
      // 确定支付渠道 - 增加小程序环境判断
      let channel = "alipay";

      // 判断是否在微信或小程序环境
      const isInWechatEnv =
        _wx.isWx || (_wx.isMiniProgram !== undefined && _wx.isMiniProgram);

      // 检测是否存在wx.miniProgram对象（更可靠的小程序环境检测）
      const hasMiniProgramAPI = typeof wx !== "undefined" && wx.miniProgram;

      if (isInWechatEnv || hasMiniProgramAPI) {
        channel = "weixin_mp";
        console.log("检测到微信/小程序环境，使用微信支付渠道");
      }

      // 保存订单ID到会话存储
      const orderId = this.orderList.length > 0 ? this.orderList[0].id : "";
      window.sessionStorage.setItem("orderId", orderId);

      // 构建回调URL
      let callbackUrl = encodeURIComponent(
        `${hostUrl}/mobile/pay-success?ad_code=${this.adCode}&orderId=${orderId}`
      );
      console.log(window.location.href, "==========window.location.href");
      // 获取当前页面URL，传递给服务器以帮助注册
      const currentUrl = encodeURIComponent(window.location.href);

      // 发送支付请求
      const res = await pay({
        c: "order",
        v: "pay2",
        serial_number: this.serialNumber,
        channel: channel,
        openid: this.openid,
        callback_url: callbackUrl,
        current_url: currentUrl, // 增加当前URL参数
      });

      this.isPaying = false;
      console.log(isInWechatEnv, hasMiniProgramAPI, "====hasMiniProgramAPI");
      // 根据支付环境处理支付结果
      if (isInWechatEnv || hasMiniProgramAPI) {
        // 微信/小程序环境下调用微信支付
        try {
          _wx.pay(res.data.order_param, () => {
            console.log("=====>>>>支付成功");
            wx.miniProgram.navigateBack();
          });
        } catch (error) {
          console.error("支付调用失败:", error);
          // 降级处理：直接跳转到支付URL
          if (res.data && res.data.url) {
            window.location.href = res.data.url;
          } else {
            this.showNotification("支付调用失败，请重试");
          }
        }
      } else {
        console.error("支付调用失败:000000000");
        // 非微信环境直接跳转到支付URL
        window.location.href = res.data.url;
      }
    },

    // 跳转到协议详情页面
    goToAgreementDetail() {
      this.$router.push({ name: "advise" });
    },
  },
  created() {
    // 初始化协议选中状态
    this.isAgreementSelected = store.checked;
  },
  mounted() {
    // 不再直接在这里初始化，而是通过 watch 监听来触发
  },
};
</script>

<style lang="scss" scoped>
.mini-pay {
  padding: 0 0.3rem;

  .head {
    width: 100%;
    height: 2.4rem;
    display: -webkit-flex;
    display: flex;
    align-items: center;

    .name {
      flex: 1;
      font-size: 0.48rem;
      font-weight: 500;
    }

    .img {
      flex: 1;
      text-align: right;

      img {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 0.8rem;
        float: right;
        border: 0.1rem solid #fff;
        box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .msg {
    .item {
      display: -webkit-flex;
      display: flex;
      font-size: 0.32rem;
      height: 0.9rem;
      align-items: center;

      &:first-child {
        border-bottom: 1px solid #e6e6e6;
      }

      .item-name {
        flex: 1;
        text-align: left;
        color: rgba(64, 64, 64, 0.6);
      }

      .item-value {
        flex: 1;
        text-align: right;
      }
    }
  }

  .pay-btn {
    width: 100%;
    display: block;
    height: 0.88rem;
    background: rgba(0, 147, 240, 1);
    border: 1px solid rgba(229, 229, 229, 1);
    color: #fff;
    font-size: 0.34rem;
    margin-top: 1.2rem;
  }

  .pay-agree {
    display: flex;
    margin-top: 0.4rem;

    .wrap {
      height: calc(0.32rem * 1.6);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &_select {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 6rem;
      margin-right: 0.15rem;
      border: 1px solid #666;
      display: flex;
      justify-content: center;
      align-items: center;

      .success {
        width: 0.06rem;
        height: 0.12rem;
        margin-top: -0.03rem;
        border-right: 0.03rem solid #fff;
        border-bottom: 0.03rem solid #fff;
        transform: rotate(45deg);
      }
    }

    .selected {
      border-color: #fff;
      background-color: #0093f0;
    }

    &_title {
      font-size: 0.32rem;
      color: rgba(0, 0, 0, 1);
    }

    &_content {
      font-size: 0.26rem;
      color: rgba(24, 24, 25, 0.7);
    }
  }
}

.insurance-banner {
  margin-top: 1.2rem;
  padding-bottom: 1.2rem;

  img {
    width: 100%;
    height: auto;
    box-shadow: 0px 2px 12px 0px rgba(160, 160, 160, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/miniPay.vue